const AttachmentDocumentRequiredType = {
  File: "FILE",
  UrlOrFile: "URL_OR_FILE"
};

export { AttachmentDocumentRequiredType };
//# sourceMappingURL=attachment-document-required-type.mjs.map
